module.exports = __webpack_public_path__ + "static/img/solution-y-3.d899ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-y-3.png
// module id = rdRi
// module chunks = 10